import DOMPurify from 'dompurify';

/**
 * Utility functions for string manipulation
 */

/**
 * Truncates an email address if it's longer than the specified length
 * @param {string} email - Email address to truncate
 * @param {number} maxLength - Maximum length (default: 20)
 * @returns {string} Truncated email or original if shorter
 */
export const truncateEmail = (email, maxLength = 20) => {
  if (!email) return '';
  return email.length > maxLength ? `${email.substring(0, maxLength)}...` : email;
};

/**
 * Strips HTML tags from a string using DOMPurify for security
 * @param {string} html - HTML string
 * @returns {string} Plain text without HTML tags
 */
export const stripHtmlTags = (html) => {
  if (!html) return '';
  // Use DOMPurify for secure HTML stripping - much safer than regex
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: [], // No tags allowed
    ALLOWED_ATTR: []  // No attributes allowed
  }).trim();
};

/**
 * Sanitizes text input to prevent XSS while preserving basic formatting
 * @param {string} text - Text to sanitize
 * @returns {string} Sanitized text
 */
export const sanitizeTextInput = (text) => {
  if (!text) return '';
  // Allow only basic formatting tags and strip all attributes
  return DOMPurify.sanitize(text, {
    ALLOWED_TAGS: ['b', 'i', 'em', 'strong', 'p', 'br'],
    ALLOWED_ATTR: []
  }).trim();
};

